<template>
  <!-- 学历统计 -->
  <div class="box fl">
    <div class="line">
      <h1>性别分布统计</h1>
      <el-divider></el-divider>
    </div>
    <div class="tu">
      <div
        style="width:100%;height:100%"
        class="chart-class"
        ref="gender"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sexList: "",
  },
  computed: {
    nameList() {
      return this.sexList.map((item) => item.name);
    },
  },
  data() {
    return {};
  },
  created() {
    this.sexList.forEach((item) => {
      item.value = item.nums;
    });
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let option = {
        color: ["#597EF7", "#FF7250"],
        //中间固定的得分
        // title: [
        //   {
        //     text: "性别比例统计",
        //     x: "50%",
        //     y: "0%",
        //     textAlign: "center",
        //     textStyle: {
        //       fontSize: "24",
        //       fontWeight: "700",
        //       color: "#555",
        //       textAlign: "center",
        //     },
        //   },
        // ],
        legend: {
          x: "center",
          top: "2%",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 13,
          },
          //原点
          icon: "circle",
          //修改icon图形大小
          itemHeight: 6,
          data: this.nameList,
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            type: "pie",
            roseType: "radius",
            radius: ["30%", "60%"],
            center: ["50%", "60%"],
            data: this.sexList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0,0,0,0.5)",
              },
            },
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.gender);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .line {
    position: relative;
    top: 0px;
    left: 0px;
    .el-divider--horizontal {
      position: absolute;
      top: 50px;
      left: 0px;
    }
    h1 {
      font-size: 24px;
      font-weight: 700;
      position: absolute;
      top: 1px;
      left: 60px;
    }
  }
  width: 278px;
  height: 282px;
  margin-bottom: 24px;
  box-sizing: border-box;
  margin-right: 24px;
  background: #fff;
  border-radius: 7px;
  padding: 20px 24px;
  .tu {
    margin-top: 40px;
    width: 100%;
    height: 200px;
  }
}
</style>
